import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33cdc51b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-mod-content__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mod_frame_flow_chart = _resolveComponent("mod-frame-flow-chart")!
  const _component_mod_frame_molecule_overview = _resolveComponent("mod-frame-molecule-overview")!
  const _component_mod_frame_many_molecules = _resolveComponent("mod-frame-many-molecules")!
  const _component_mod_frame_enter_body = _resolveComponent("mod-frame-enter-body")!
  const _component_mod_frame_virus_entry = _resolveComponent("mod-frame-virus-entry")!
  const _component_mod_frame_virus_infusion = _resolveComponent("mod-frame-virus-infusion")!
  const _component_mod_frame_virus_rna = _resolveComponent("mod-frame-virus-rna")!
  const _component_mod_frame_breakdown = _resolveComponent("mod-frame-breakdown")!
  const _component_mod_frame_encoded = _resolveComponent("mod-frame-encoded")!
  const _component_mod_frame_mutagenesis = _resolveComponent("mod-frame-mutagenesis")!
  const _component_mod_frame_rna_replication = _resolveComponent("mod-frame-rna-replication")!
  const _component_mod_frame_membrane = _resolveComponent("mod-frame-membrane")!
  const _component_mod_frame_vitamin_release = _resolveComponent("mod-frame-vitamin-release")!
  const _component_mod_frame_vitamin_exit = _resolveComponent("mod-frame-vitamin-exit")!
  const _component_mod_credits = _resolveComponent("mod-credits")!
  const _component_mod_frame_box = _resolveComponent("mod-frame-box")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-mod-content hd-container js-timeline-container-2", { 'is-ready': _ctx.ready }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_mod_frame_flow_chart, {
        class: "hd-mod-content__content",
        ready: _ctx.ready
      }, null, 8, ["ready"]),
      _createVNode(_component_mod_frame_molecule_overview, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_many_molecules, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_enter_body, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_virus_entry, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_virus_infusion, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_virus_rna, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_breakdown, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_encoded, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_mutagenesis, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_rna_replication, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_membrane, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_vitamin_release, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_frame_vitamin_exit, { class: "hd-mod-content__content" }),
      _createVNode(_component_mod_credits, { class: "hd-mod-content__content" })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datum, (frame) => {
      return (_openBlock(), _createBlock(_component_mod_frame_box, {
        key: frame.endpointId,
        "endpoint-id": frame.endpointId,
        class: _normalizeClass({ 'is-no-frame-box': frame['no-frame-box'] === 'true' })
      }, null, 8, ["endpoint-id", "class"]))
    }), 128))
  ], 2))
}